module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/PSYCHOLOGY-6c05da61fdf68b0bce246326a48e46f2.png";